import { render, staticRenderFns } from "./initiate.vue?vue&type=template&id=e74f8e3a&scoped=true&"
import script from "./initiate.vue?vue&type=script&lang=js&"
export * from "./initiate.vue?vue&type=script&lang=js&"
import style0 from "./initiate.vue?vue&type=style&index=0&id=e74f8e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74f8e3a",
  null
  
)

export default component.exports